import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HapticsService {

  vibrate(durationOrPattern: number | number[]): void {
    try {
      if ('vibrate' in navigator) {
        navigator.vibrate(durationOrPattern);
      } else {
        console.warn('Vibration API not supported on this device.');
      }
    } catch (error) {
      console.error('Vibration failed:', error);
    }
  }

  vibrateShort(): void {
    this.vibrate(50);
  }

  vibrateLong(): void {
    this.vibrate([100, 50, 100]);
  }
}
